import SideBar from "../../components/navigation/SideBar";
import TableCard from "../../components/tables/TableCard";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useCreateExerciseMutation } from "../../store";
import StandardForm from "../../components/forms/StandardForm";
import { useCoach } from "../../hooks/useCoach";
import { useState } from "react";

function CreateExerciseForm(){
  const { coach } = useCoach();
  const navigate = useNavigate();
  const [createExercise, results] = useCreateExerciseMutation();

  const meta = {
      object: "Exercise",
      action: "Create new Exercise",
      description: "Create a new exercise record.",
    };
  
  const config = [
    {
      id:'name',
      label: 'Exercise name',
      type: 'shortText',
      placeholder: 'Bench Press',
      size: 2
    },
    {
      id:'video_tutorial_en',
      label: 'Link to video in english',
      type: 'shortText',
      placeholder: 'Video tutorial link',
      size: 2
    },
    {
      id:'video_tutorial_es',
      label: 'Link to video in spanish',
      type: 'shortText',
      placeholder: 'Video tutorial link',
      size: 2
    },
    {
      id:'description',
      label: 'Exercise Description',
      type: 'richtext',
      placeholder: 'Write how to conduct the exercise.',
      size: 'full'
    },
    {
      id: 'is_kpi',
      label: 'Is KPI?',
      type: 'check',
      placeholder: '',
      size: '2'
    },
  ];
  

  const keyFn = (exercise) => {
    return exercise.id;
  };
  const handleCreate = (e)=> {
    e.preventDefault();
    const submitData = config.reduce((o, input) => {
      // Si el tipo del campo es checkbox, obtener su estado 'checked'
      if (input.type === 'check') {
        const checkbox = e.target.elements[input.id];
        return {
          ...o,
          [input.id]: checkbox ? checkbox.checked : false,
        };
      }
  
      // Para otros tipos de campos, usar el valor
      return {
        ...o,
        [input.id]: e.target[input.id]?.value,
      };
    }, {});
    submitData.coach = coach.id;
    createExercise(submitData);
    navigate("/exercises");
  }

  return (
    <>
    <div>
      <SideBar/>
      <main className="py-10 lg:pl-72">
        <div className="px-4 sm:px-6 lg:px-8">
          <StandardForm meta={meta} config={config} colsForm={1} onSubmit={handleCreate}/>
        </div>
      </main>
    </div>
    </>
  );
}

export default CreateExerciseForm;